module.exports = __webpack_public_path__ + "img/fmicon.7d375884.svg";